// ============== Schools ==============================
// GET METHODS
export const listschool = "/school";
export const listEstablishments = "/school/list-of-staff?page=1&limit=100";
export const listCountry = "/school/country";
export const getSchoolStaff = "/school/school-staff/get";
export const listOfStaff = "/list-of-staff?page=1&limit=100";

// POST METHODS
export const notificationAdd = "/school/notification/add";
export const updateUserInfo = "/school/school-staff/update";

// ============== Auth ==============================
// GET METHODS
export const userProfile = "/school/user/profile";

// POST METHODS
export const login = "/school/auth";
export const termAccepted = "/school/user/terms-accepted";
export const confirmEmail = "/school/auth/confirm-email";
export const resetPassword = "/school/auth/reset-password";
export const register = "/school/auth/register";

// ============== Program ==============================
// GET METHODS
export const programs = "/school/program";
export const programType = "/program-type";
export const programMajor = "/program-major?limit=100";

// POST METHODS
export const linkProgram = "/school/school-staff/update";
export const uploadBrochure = "/school/program-campaign/update";

// ============== Survey ==============================

// POST METHODS
export const startSurvey = "/school/survey/start";
export const listLaunchYear = "/survey/launchYear";
export const updateSurvey = "/school/survey/update";
export const fisnishSurvey = "/school/survey/finish";
export const downloadPdfFile = "/school/survey/pdf";

// ============== Recruiter ==============================

// POST METHODS
export const registerRecruiter = "/recruiter/auth/register";
export const infoProgramRecruiter = "/recruiter/auth/register";
